export default "__VITE_PUBLIC_ASSET__334d2229__"